import {
    formatPermissionName,
    PermissionAction,
} from '@experiences/interfaces';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/**
 * Returns the "insufficient permissions" tooltip text naming the Licensing **LicensingData / Manage**
 * permission, reusing the same i18n key and permission formatting as `UiPermissionGuard`.
 * Use as the tooltip of an action that is disabled because Manage is missing
 * (see {@link useCanManageLicensingData}).
 */
export const useLicensingManagePermissionTooltip = (): string => {
    const { formatMessage: translate } = useIntl();

    return useMemo(
        () => translate(
            { id: 'CLIENT_PERMISSION_GUARD_INSUFFICIENT_PERMISSIONS' },
            { permissions: formatPermissionName(PermissionAction.Licensing.LicensingData.Manage) },
        ),
        [ translate ],
    );
};
